export default {
    delivery: {},
    payment:{}
}